import { render, staticRenderFns } from "./sysRolerole.vue?vue&type=template&id=4127981d&scoped=true"
import script from "./sysRolerole.vue?vue&type=script&lang=js"
export * from "./sysRolerole.vue?vue&type=script&lang=js"
import style0 from "./sysRolerole.vue?vue&type=style&index=0&id=4127981d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4127981d",
  null
  
)

export default component.exports